import React from 'react';
import MemberSpecial from './MemberSpecial';

const Students = (props: any) => <MemberSpecial {...props} />;

export default Students;
